





































































import {
  Component,
  Vue,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import PropertyDevicePerformanceTable from "@/components/dashboard/PropertyDevicePerformanceTable.vue";
import { formatService } from "../../services/format.service";
import { IProperty } from "../../models/interfaces/property/property.model.interface";
import { IZoneOverview } from "../../models/interfaces/overview/zone-overview.model.interface";


const PropertyPerformanceModule = namespace("propertyPerformanceModule");
const PublisherModule = namespace("publisherModule");
const UserSelectionModule = namespace("userSelectionModule");
const ZoneEnquiryModule = namespace("zoneEnquiryModule");
const UserModule = namespace("userModule");

@Component({
  components: {
    Loader,
    "device-performance" : PropertyDevicePerformanceTable
  }
})
export default class PropertyPerformanceTable extends Vue {

  @Provide() public currentPage = 1;
  @Provide() public perPage = 10;
  @Provide() public totalRows = 0;

  get getSelectedProperty(): IProperty | null {
    return this.selectedProperty;
  }

  get getPerformanceData(): IZoneOverview[] {
    return this.zonesOverview;
  }

  get getEnquiriesLoaded(): boolean {
    return this.zoneEnquiriesLoaded;
  }

  get getDates(): Date {
    return this.selectedDates;
  }

  get showPagination(): boolean {
    return this.items.length > this.perPage;
  }

  public getRowCount(items) {
    return items.length;
  }

  @UserModule.Getter public isAdmin;
  @PropertyPerformanceModule.Getter public propertyZoneDevicePerformance;
  @PropertyPerformanceModule.Action public retrievePropertyZonePerformance;
  @PropertyPerformanceModule.Action public retrievePropertyZoneDevicePerformance;
  @PropertyPerformanceModule.Getter public propertyZonePerformance;
  @PropertyPerformanceModule.Getter public zoneLoadsCount;
  @PropertyPerformanceModule.Getter public zoneImpressionCount;
  @PropertyPerformanceModule.Getter public zoneClicksCount;
  @PropertyPerformanceModule.Getter public zoneKeypressCount;
  @UserSelectionModule.Getter public selectedDates;
  @PublisherModule.Getter public selectedProperty: IProperty | null;
  @ZoneEnquiryModule.Getter public zonesOverview;
  @ZoneEnquiryModule.Getter public zoneEnquiriesLoaded;
  @ZoneEnquiryModule.Action public retrieveZoneEnquiryPerformance;

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: false })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop({ default: false })
  public revenueAccess: boolean;

  @Provide() public property: IProperty | null = null;

  @Provide() public enquiriesLoaded: boolean = false;

  @Provide() public items: IZoneOverview[] = [];

  @Provide()
  public columns = [
    {
      key: "performance.zone",
      label: "Zone",
      sortable: true,
       formatter: (value, key, item) => {
        return value;
      }
    },
    {
      key: "performance.impressions",
      label: "Content Impressions",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.performance.impressions,
          item.performance.loads
        );
      }
    },
    {
      key: "performance.keyPresses",
      label: "Interactions",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.performance.keyPresses,
          item.performance.impressions
        );
      }
    },
    {
      key: "performance.clicks",
      label: "Click Throughs",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.performance.clicks,
          item.performance.impressions
        );
      }
    },
    {
      key: "enquiry.enquiries",
      label: "Leads Generated",
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.enquiry.enquiries,
          item.performance.clicks
        );
      },
      class: this.revenueAccess ? "" : "d-none"
    },
    {
      key: "enquiry.rejections",
      label: "Lead Rejections",
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.enquiry.rejections,
          item.enquiry.enquiries
        );
      },
      class: this.revenueAccess ? "" : "d-none"
    },
    {
      key: "enquiry.revenue",
      label: "Revenue",
      formatter: (value, key, item) => {
        return formatService.formatCurrency(value);
      },
      class: this.revenueAccess ? "" : "d-none"
    },
    { key: "actions", label: "Actions" }
  ];

  private showDeviceTable: boolean = false;

  private loading: boolean = true;

  @Watch("getSelectedProperty")
  public onSelectedPropertyChanged() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }

  @Watch("selectedDates")
  public onDatesChanged() {
    this.updatePerformanceData();
  }

  @Watch("zonesOverview")
  public onOverviewChanged() {
    this.items = this.zonesOverview.filter((x) => x.performance && x.performance.zone !== null);
  }

  @Watch("zoneEnquiriesLoaded")
  public onEnquiriesLoaded() {
    this.enquiriesLoaded = this.getEnquiriesLoaded;
  }

  public buttonToggled() {
    this.showDeviceTable = !this.showDeviceTable;
  }

  public getLoadSummary() {
    return formatService.formatNumber(this.zoneLoadsCount);
  }

  public getImpressionSummary() {
    return formatService.formatNumberPercentage(
      this.zoneImpressionCount,
      this.zoneImpressionCount,
      this.zoneLoadsCount
    );
  }

  public getClickSummary() {
    return formatService.formatNumberPercentage(
      this.zoneClicksCount,
      this.zoneClicksCount,
      this.zoneImpressionCount
    );
  }

  public getKeypressSummary() {
    return formatService.formatNumberPercentage(
      this.zoneKeypressCount,
      this.zoneKeypressCount,
      this.zoneImpressionCount
    );
  }

  public get enquiryCount(): number {
    return this.items.map(item => item.enquiry.enquiries).reduce((a, b) => a + b, 0);
  }

  public getEnquirySummary() {
    return formatService.formatNumberPercentage(
      this.enquiryCount,
      this.enquiryCount,
      this.zoneClicksCount
    );
  }

  public get conversionCount(): number {
    return this.items.map(item => item.enquiry.conversions).reduce((a, b) => a + b, 0);
  }

  public getConversionsSummary() {
    return formatService.formatNumberPercentage(
      this.conversionCount,
      this.conversionCount,
      this.zoneClicksCount
    );
  }

  public get revenueCount(): number {
    return this.items.map(item => item.enquiry.revenue).reduce((a, b) => a + b, 0);
  }

  public getRevenueSummary() {
    return formatService.formatCurrency(this.revenueCount);
  }

  public updatePerformanceData() {
    this.loading = true;
    this.enquiriesLoaded = false;

    if (this.property) {
      Promise.race([
        this.retrievePropertyZonePerformance(this.property.propertyId),
        this.retrieveZoneEnquiryPerformance(this.property.propertyId),
        this.retrievePropertyZoneDevicePerformance(this.property.propertyId)
      ]).then((result) => {
          if (result) {
            this.enquiriesLoaded = this.getEnquiriesLoaded;
            this.items = this.zonesOverview.filter((x) => x.performance && x.performance.zone !== null);
          }
          this.loading = false;
        }
      );
    }
  }

 public created() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }
}
